var $class="se2--country-selector-section",$name="countrySelectorSection",$path="app/partials/countrySelectorSection/config.js",$this={$class,$name,$path,};// eslint-disable-next-line import/prefer-default-export
export const countrySelectorSectionSelector = `.${$class}`;
